import React, { useState } from "react";

export const Dropdown = ({
  heading,
  items,
  setActiveItem,
  activeItem,
  keyValue = "name",
  displayTitle = false,
  style = {},
}) => {
  const [ddHeading, setddHeading] = useState(
    activeItem ? activeItem[keyValue] : heading
  );
  const [open, setOpen] = useState(false);
  return (
    <div style={style} class="styling-wrap__dropdown">
      {activeItem && displayTitle && (
        <p className="styling-wrap__dropdown-heading">{heading}</p>
      )}
      <div
        onClick={() => setOpen(!open)}
        className={`
          styling-wrap__dropdown-selected ${
            items.includes(activeItem) ? "selected" : ""
          }
        `}
      >
        <p>{items.includes(activeItem) ? ddHeading : heading}</p>
      </div>
      <div
        style={style}
        className={`styling-wrap__dropdown-dropdown ${open ? "open" : ""}`}
      >
        {items &&
          items.map((item) => {
            return (
              <p
                onClick={() => {
                  setddHeading(item[keyValue]);
                  setActiveItem(item);
                  setOpen(false);
                }}
              >
                {item[keyValue]}
              </p>
            );
          })}
      </div>
    </div>
  );
};
